/* eslint-disable max-lines-per-function */
import { Button } from 'primereact/button'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import donViDangKyDuThiProcessor from '../../../processor/donViDangKyDuThiProcessor'
import khoaThiProcessor from '../../../processor/khoaThiProcessor'
import namProcessor from '../../../processor/namProcessor'
import xacMinhVanBangProcessor from '../../../processor/xacMinhVanBangProcessor'
import { setDonViDangKyDuThis } from '../../../store/reducer/donViDangKyDuThi'
import { setKhoaThiId, setKhoaThis } from '../../../store/reducer/khoaThi'
import { setNamId, setNams } from '../../../store/reducer/nam'
import store from '../../../store/store'
import ListVanBangWithView from '../ListVanBangWithView'
import AddsTraCuu from './AddsTraCuu'
import AddTraCuu from './AddTraCuu'
import LichSuXacMinh from './LichSuXacMinh'

export default function TraCuu() {
  const userTruong = useSelector((item) => item.user.info.truongId)
  const userDonVi = useSelector((item) => item.user.info.donVi)
  const namId = useSelector((item) => item.nam.id)
  const khoaThiId = useSelector((item) => item.khoaThi.id)
  const processor = xacMinhVanBangProcessor
  const [visibleAdd, setVisibleAdd] = useState(false)
  const [visibleAdds, setVisibleAdds] = useState(false)
  const [visibleLichSu, setVisibleLichSu] = useState(false)
  const [vanBang, setVanBang] = useState(null)
  const [selected, setSelected] = useState([])
  const toggleAdd = () => setVisibleAdd(!visibleAdd)
  const toggleAdds = () => setVisibleAdds(!visibleAdds)
  const toggleLichSu = () => setVisibleLichSu(!visibleLichSu)
  const getXacMinhVanBang = (data) => {
    setVanBang({ ...data })
    toggleAdd()
  }
  const addVanBang = async (data) => {
    const rs = await processor.upsert({ ...data })
    if (rs.isSuccess) {
      const link = document.createElement('a')
      link.href = `/${rs.data}`
      link.setAttribute('download', `van_ban_xac_nhan.docx`)
      link.click()
    }
  }
  const addsVanBang = async (data) => {
    const rs = await processor.createsWithFile({
      ...data,
      vanBangs: selected.map((item) => item.id).toString(),
    })
    if (rs.isSuccess) {
      window.open(rs.data.docx)
      window.open(rs.data.excel)
    }
  }
  const buttons =
    userTruong !== 0
      ? [
          (data) => {
            return {
              icon: 'pi pi-check',
              className: 'p-button-rounded p-button-success mr-2',
              tooltip: 'Xác nhận',
              tooltipOptions: { position: 'top' },
              onClick: async () => {
                const rs = await xacMinhVanBangProcessor.truongXacNhan(data.id)
                if (rs.isSuccess) {
                  const link = document.createElement('a')
                  link.href = `/${rs.data}`
                  link.setAttribute('download', `van_ban_xac_nhan.docx`)
                  link.click()
                }
              },
            }
          },
        ]
      : [
          (data) => {
            return {
              icon: 'pi pi-check',
              className: 'p-button-rounded p-button-success mr-2',
              tooltip: 'Xác nhận',
              tooltipOptions: { position: 'top' },
              onClick: () => getXacMinhVanBang(data),
            }
          },
          (data) => {
            return {
              icon: 'pi pi-history',
              className: 'p-button-rounded p-button-warning mr-2',
              tooltip: 'Lịch sử xác nhận',
              tooltipOptions: { position: 'top' },
              onClick: () => {
                setVanBang({ ...data })
                toggleLichSu()
              },
            }
          },
        ]
  const addition = []
  const getNam = async () => {
    let rs = await namProcessor.getAll()
    rs = [{ id: 0, name: 'Năm' }, ...rs]
    store.dispatch(setNams(rs))
    if (rs.length > 0) {
      store.dispatch(setNamId(rs[0].id))
    }
  }
  const getKhoaThi = async () => {
    let rs
    if (namId === 0) {
      rs = await khoaThiProcessor.getAll()
      rs = [{ id: 0, date: 'Khoá thi' }, ...rs]
    } else {
      rs = await khoaThiProcessor.getByNam(namId)
    }
    if (rs.length > 0) {
      store.dispatch(setKhoaThiId(rs[0].id))
    }
    store.dispatch(setKhoaThis(rs))
  }
  const getDonViDK = async () => {
    let rs
    if (khoaThiId) {
      rs = await donViDangKyDuThiProcessor.getByKhoaThi(khoaThiId)
    } else {
      rs = await donViDangKyDuThiProcessor.getAll()
    }
    store.dispatch(setDonViDangKyDuThis(rs))
  }
  return (
    <>
      <AddTraCuu
        visible={visibleAdd}
        toggle={toggleAdd}
        vanBang={vanBang}
        save={addVanBang}
        donVi={userDonVi}
      />
      <AddsTraCuu
        visible={visibleAdds}
        toggle={toggleAdds}
        selected={selected}
        save={addsVanBang}
        donVi={userDonVi}
      />
      <LichSuXacMinh visible={visibleLichSu} toggle={toggleLichSu} vanBang={vanBang} />
      <ListVanBangWithView
        getNam={getNam}
        getKhoaThi={getKhoaThi}
        getDonViDK={getDonViDK}
        additionColumn={addition}
        headerLeft={
          <div>
            {!userTruong && (
              <Button
                icon="pi pi-check"
                className="p-button-success"
                disabled={selected.length === 0}
                label={`Xác nhận ${selected.length} học sinh`}
                onClick={toggleAdds}
              />
            )}
          </div>
        }
        moduleTitle="Tra cứu văn bằng"
        buttons={buttons}
        {...{ selected, setSelected }}
      />
    </>
  )
}
